import React from 'react';
import RustikSettings from './settings/RustikSettings';
import TulKanatSettings from './settings/TulKanatSettings';
import JaluziSettings from './settings/JaluziSettings';
import StorZebraSettings from './settings/StorZebraSettings';
import DikeySettings from './settings/DikeySettings';
import KatlamaliSettings from './settings/KatlamaliSettings';
import PliseSettings from './settings/PliseSettings';
import SettingsSaveBar from './SettingsSaveBar';

const SETTINGS_TABS = new Set([
  'tul',
  'kanat',
  'ahsapJaluzi',
  'metalJaluzi',
  'stor',
  'zebra',
  'dikeyPerde',
  'dikeyPvc',
  'dikeyStor',
  'katlamaliPerde',
  'plise'
]);

const ProductTypeSettings = React.memo(({
  activeTypeTab,
  canEditProducts,
  handleSaveSettings,
  isSavingSettings,
  rustikExtras,
  setRustikExtras,
  rustikStates,
  tulExtraPrices,
  setTulExtraPrices,
  kanatExtraPrices,
  setKanatExtraPrices,
  jaluziExtras,
  setJaluziExtras,
  metalJaluziExtras,
  setMetalJaluziExtras,
  storExtras,
  setStorExtras,
  zebraExtras,
  setZebraExtras,
  dikeyExtras,
  setDikeyExtras,
  dikeyPvcExtras,
  setDikeyPvcExtras,
  dikeyStorExtras,
  setDikeyStorExtras,
  katlamaliExtras,
  setKatlamaliExtras,
  pliseExtras,
  setPliseExtras,
  katlamaliStates,
  dikeyStates
}) => {
  const showRustik = activeTypeTab === 'rustik';
  const showTypeSettings = SETTINGS_TABS.has(activeTypeTab);
  const showSettingsPanel = showRustik || showTypeSettings;
  const readOnly = !canEditProducts;

  if (!showSettingsPanel) return null;

  return (
    <div className="product-settings-container">
      <div className={`product-settings-panel${readOnly ? ' is-readonly' : ''}`}>
        <div className="product-settings-panel-body">
          {showRustik && (
            <RustikSettings
              rustikExtras={rustikExtras}
              setRustikExtras={setRustikExtras}
              {...rustikStates}
              handleSaveSettings={handleSaveSettings}
            />
          )}

          {(activeTypeTab === 'tul' || activeTypeTab === 'kanat') && (
            <TulKanatSettings
              extraPrices={activeTypeTab === 'tul' ? tulExtraPrices : kanatExtraPrices}
              setExtraPrices={activeTypeTab === 'tul' ? setTulExtraPrices : setKanatExtraPrices}
              activeTypeTab={activeTypeTab}
            />
          )}

          {(activeTypeTab === 'ahsapJaluzi' || activeTypeTab === 'metalJaluzi') && (
            <JaluziSettings
              activeTypeTab={activeTypeTab}
              jaluziExtras={jaluziExtras}
              setJaluziExtras={setJaluziExtras}
              metalJaluziExtras={metalJaluziExtras}
              setMetalJaluziExtras={setMetalJaluziExtras}
            />
          )}

          {(activeTypeTab === 'stor' || activeTypeTab === 'zebra') && (
            <StorZebraSettings
              activeTypeTab={activeTypeTab}
              storExtras={storExtras}
              setStorExtras={setStorExtras}
              zebraExtras={zebraExtras}
              setZebraExtras={setZebraExtras}
            />
          )}

          {(activeTypeTab === 'dikeyPerde' || activeTypeTab === 'dikeyPvc' || activeTypeTab === 'dikeyStor') && (
            <DikeySettings
              activeTypeTab={activeTypeTab}
              dikeyExtras={dikeyExtras}
              setDikeyExtras={setDikeyExtras}
              dikeyPvcExtras={dikeyPvcExtras}
              setDikeyPvcExtras={setDikeyPvcExtras}
              dikeyStorExtras={dikeyStorExtras}
              setDikeyStorExtras={setDikeyStorExtras}
              {...dikeyStates}
              handleSaveSettings={handleSaveSettings}
            />
          )}

          {activeTypeTab === 'katlamaliPerde' && (
            <KatlamaliSettings
              katlamaliExtras={katlamaliExtras}
              setKatlamaliExtras={setKatlamaliExtras}
              {...katlamaliStates}
              handleSaveSettings={handleSaveSettings}
            />
          )}

          {activeTypeTab === 'plise' && (
            <PliseSettings
              pliseExtras={pliseExtras}
              setPliseExtras={setPliseExtras}
            />
          )}
        </div>

        {canEditProducts && (
          <SettingsSaveBar
            onSave={() => handleSaveSettings()}
            isSaving={isSavingSettings}
          />
        )}
      </div>
    </div>
  );
});

export default ProductTypeSettings;
